import './common-fields.scss';

import React from 'react';

import FieldLabel from './FieldLabel';
import IconChevronDown from './IconChevronDown';

type Props = {
  id: string;
  label: string;
  required?: boolean;
  value: string;
  options: FormSelectOptions;
  onChange: (val: string) => void;
  onBlur?: () => void;
  showError?: boolean;
  error?: string;
  /** When true, fully hidden in OpenReplay replay. Ignored if phiSanitize is true. */
  phiHidden?: boolean;
  /** When true, masked in OpenReplay replay. Ignored if phiHidden is true. */
  phiSanitize?: boolean;
};

export default function SelectField({
  id,
  label,
  required,
  value,
  options,
  onChange,
  onBlur,
  showError,
  error,
  phiHidden,
  phiSanitize,
}: Props) {
  const errorId = `${id}-error`;
  const openReplayAttrs = phiHidden
    ? { 'data-openreplay-hidden': true }
    : phiSanitize
      ? { 'data-openreplay-sanitize': true }
      : {};
  return (
    <div className='po-field po-select-wrapper'>
      <FieldLabel htmlFor={id} required={required}>
        {label}
      </FieldLabel>

      <select
        id={id}
        name={id}
        className='po-select'
        value={value}
        onBlur={onBlur}
        onChange={e => onChange(e.target.value)}
        aria-invalid={!!showError}
        aria-required={!!required}
        aria-describedby={showError && error ? errorId : undefined}
        {...openReplayAttrs}
      >
        <option value=''>Select</option>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <span className='po-select-icon' aria-hidden='true'>
        <IconChevronDown width={12} height={8} />
      </span>
      {showError && error ? (
        <div id={errorId} className='po-error inline' role='alert'>
          {error}
        </div>
      ) : null}
    </div>
  );
}
